// extracted by mini-css-extract-plugin
module.exports = {"rectangle":"Header_rectangle__1WwTC","shape":"Header_shape__2PkHr","rectangle2":"Header_rectangle2__dtzQO"};